export default "__VITE_ASSET__CPAtBMCR__"